<template>
  <section>
    <!-- ROUTER HEADER SHOULD GO HERE -->
    <div class="page-banner">
      <div class="container-fluid border-bottom">
        <div class="row align-items-center">
          <div class="col-md-7 p-4 pt-5">
            <h1>
              <img
                src="@/assets/img/_title/17-OTJS-make-the-most-of-your-work-experience.svg"
                class="img-fluid"
                alt="Assess your employability skills"
                srcset=""
              >
            </h1>
          </div>
        </div>
      </div>
    </div>

    <!-- ROUTER CONTENT GOES HERE -->
    <!-- TEXT CONTENT -->
    <content-block class="bg-light-grey">
      <div class="row">
        <div class="col-md bg-img bg-img--job-search-17-2">
          <!-- <img
            src="@/assets/img/_content/template-placeholder-01.jpg"
            alt=""
            class="img-fluid content-block__img"
          > -->
        </div>
        <div class="col-md-6 p-4">
          <!-- <h2 class="content-block__header">Make the most of your work experience</h2> -->
          <p>Set yourself up for the future by keeping track of your work duties and accomplishments. You may want to share these with potential employers in the future.</p>
          <p>Make sure to keep copies of your job description, notes on any discussions with your supervisor about your performance as well as any work samples, such as presentations, project outlines and reports. Later on, you can include these in your portfolio or LinkedIn profile. </p>
          <p>By tracking your accomplishments, you’ll be able to later reflect on the skills and knowledge you were able to acquire during your work experience. </p>
          <p>You can use this <a
              :href="`${publicPath}docs/Worksheets/Work log sheet.docx`"
              target="_blank"
            >work log</a> to help you keep track of everything.</p>
        </div>
      </div>
    </content-block>

    <content-block class="p-4">
      <h3 class="content-block__header">Have meaningful conversations about your work </h3>
      <p>To help you relate what you’re learning at work to what you’re learning in the classroom and your career goals, be prepared to talk about your experience with your supervisor. Remember, you can also initiate these meetings to get some feedback on your performance. </p>
      <p>Before meeting with your supervisor, reflect on these questions:</p>
      <div class="carousel carousel--purple">
        <hooper
          ref="carousel_01"
          class="mb-4"
        >
          <slide>
            <div class="slide">
              <p>What am I learning here that’s helping me in school?</p>
            </div>
          </slide>

          <slide>
            <div class="slide">
              <p>What am I learning in class that I apply here at work?</p>
            </div>
          </slide>

          <slide>
            <div class="slide">
              <p>What have been some of my successes and what strengths did I use?</p>
            </div>
          </slide>

          <slide>
            <div class="slide">
              <p>What have been some of my challenges and what have I learned from these?</p>
            </div>
          </slide>

          <slide>
            <div class="slide">
              <p>What new skills have I developed?</p>
            </div>
          </slide>

          <slide>
            <div class="slide">
              <p>What have I learned that will help my career?</p>
            </div>
          </slide>
          <hooper-navigation slot="hooper-addons">
            <img
              slot="hooper-prev"
              src="@/assets/img/_ui/svg/carousel-back--purple.svg"
              alt="previous"
              srcset=""
            >
            <img
              slot="hooper-next"
              src="@/assets/img/_ui/svg/carousel-next--purple.svg"
              alt="next"
              srcset=""
            >
          </hooper-navigation>

          <hooper-pagination slot="hooper-addons"></hooper-pagination>
        </hooper>
      </div>
      <p>Make note of any feedback you receive from your supervisor in your work log, and think about how you can improve, what else you want to learn, and what other experiences could help you grow and develop your skills.</p>
      <p>Use <a
          :href="`${publicPath}docs/Worksheets/4-Structured conversations -worksheet 4 updated.pdf`"
          target="_blank"
        >this worksheet</a> to help you plan for meaningful conversations with your supervisor.</p>
    </content-block>
  </section>
</template>

<script>
import ContentBlock from '@/components/ContentBlock.vue'
// import Accordion from '@/components/Accordion.vue'
// import SidebarMenu from '../components/SidebarMenu.vue'
import {
  Hooper,
  Slide,
  Navigation as HooperNavigation,
  Pagination as HooperPagination
} from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  name: '01',
  components: {
    ContentBlock,
    // SidebarMenu,
    // Accordion
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },

  mounted () {
  }
}
</script>

<style>
</style>
